(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lbc-brand-collections-grid"] && !Shopify.designMode) return;
  try {
    
  class LbcScrollCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.lbc-collections-grid__cards');
      this.thumb = this.querySelector('.lbc-collections-grid__thumb');
      if (!this.track || !this.thumb) return;

      this.onScroll = this.onScroll.bind(this);
      this.onWheel = this.onWheel.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      // Vertical mouse wheels don't scroll overflow-x containers; the native
      // scrollbar is hidden, so translate wheel input into horizontal scroll
      this.track.addEventListener('wheel', this.onWheel, { passive: false });
      // Recompute the thumb ratio when the viewport changes (rotation/resize)
      this.onResize = new ResizeObserver(this.onScroll);
      this.onResize.observe(this.track);
      this.onScroll();
    }

    onScroll() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const maxScroll = scrollWidth - clientWidth;
      const thumbWidth = Math.max((clientWidth / scrollWidth) * 100, 12);
      const progress = maxScroll > 0 ? scrollLeft / maxScroll : 0;
      this.thumb.style.width = thumbWidth + '%';
      this.thumb.style.left = progress * (100 - thumbWidth) + '%';
    }

    onWheel(event) {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const maxScroll = scrollWidth - clientWidth;
      if (maxScroll <= 0 || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;

      const delta = event.deltaY;
      const atStart = scrollLeft <= 0 && delta < 0;
      const atEnd = scrollLeft >= maxScroll - 1 && delta > 0;
      if (atStart || atEnd) return;

      event.preventDefault();
      this.track.scrollLeft += delta;
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.track?.removeEventListener('wheel', this.onWheel);
      this.onResize?.disconnect();
    }
  }

  if (!customElements.get('lbc-scroll-carousel')) {
    customElements.define('lbc-scroll-carousel', LbcScrollCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbc-brand-gallery"] && !Shopify.designMode) return;
  try {
    
  class LbcGalleryCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.prev = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      if (!this.track) return;

      this.onScroll = this.onScroll.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onPrev = () => this.step(-1);
      this.onNext = () => this.step(1);

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.track.addEventListener('keydown', this.onKeydown);
      this.prev?.addEventListener('click', this.onPrev);
      this.next?.addEventListener('click', this.onNext);

      // Re-evaluate the end stops on resize/rotate, and once images have laid
      // out - scrollWidth is wrong until then.
      this.resizeObserver = new ResizeObserver(this.onScroll);
      this.resizeObserver.observe(this.track);
      this.onScroll();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.track?.removeEventListener('keydown', this.onKeydown);
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);
      this.resizeObserver?.disconnect();
    }

    /**
     * Each slide's start position in the track's own scroll coordinates.
     * Measured from rects rather than offsetLeft, which is relative to the
     * nearest positioned ancestor and so unreliable here.
     */
    slideOffsets() {
      const trackLeft = this.track.getBoundingClientRect().left;
      const padding = parseFloat(getComputedStyle(this.track).paddingInlineStart) || 0;
      return Array.from(this.track.children).map(
        (slide) => slide.getBoundingClientRect().left - trackLeft + this.track.scrollLeft - padding
      );
    }

    /** Advance one image in `direction` (-1 back, 1 forward). */
    step(direction) {
      const offsets = this.slideOffsets();
      const current = this.track.scrollLeft;
      // 2px of slack so a snap that landed a hair off doesn't re-target itself
      const target =
        direction > 0
          ? offsets.find((offset) => offset > current + 2)
          : offsets.filter((offset) => offset < current - 2).pop();

      const max = this.track.scrollWidth - this.track.clientWidth;
      const left = target === undefined ? (direction > 0 ? max : 0) : Math.min(Math.max(target, 0), max);

      this.track.scrollTo({
        left,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    }

    onKeydown(event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      // Take over from the browser's small default scroll increment so the
      // keyboard steps image by image, like the arrows.
      event.preventDefault();
      this.step(event.key === 'ArrowRight' ? 1 : -1);
    }

    onScroll() {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const max = scrollWidth - clientWidth;
      const scrollable = max > 1;

      this.toggleAttribute('data-static', !scrollable);
      if (this.prev) this.prev.disabled = !scrollable || scrollLeft <= 1;
      if (this.next) this.next.disabled = !scrollable || scrollLeft >= max - 1;
    }
  }

  if (!customElements.get('lbc-gallery-carousel')) {
    customElements.define('lbc-gallery-carousel', LbcGalleryCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbc-brand-hero-media"] && !Shopify.designMode) return;
  try {
    
  class LbcSoundToggle extends HTMLElement {
    connectedCallback() {
      this.video = this.closest('.lbc-hero-media').querySelector('.lbc-hero-media__video');
      this.addEventListener('click', () => this.toggle());
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.toggle();
        }
      });
    }

    toggle() {
      if (!this.video) return;
      this.video.muted = !this.video.muted;
      this.setAttribute('aria-pressed', String(!this.video.muted));
      this.classList.toggle('is-unmuted', !this.video.muted);
    }
  }

  if (!customElements.get('lbc-sound-toggle')) {
    customElements.define('lbc-sound-toggle', LbcSoundToggle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbc-hero-video"] && !Shopify.designMode) return;
  try {
    
  class LbcWordRotator extends HTMLElement {
    connectedCallback() {
      this.words = (this.dataset.words || '')
        .split(',')
        .map((word) => word.trim())
        .filter(Boolean);

      if (this.words.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.index = 0;
      const interval = parseInt(this.dataset.interval, 10) || 2400;
      this.timer = setInterval(() => this.showNext(), interval);
    }

    showNext() {
      this.index = (this.index + 1) % this.words.length;
      this.classList.remove('is-animating');
      void this.offsetWidth;
      this.textContent = this.words[this.index];
      this.classList.add('is-animating');
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }
  }

  if (!customElements.get('lbc-word-rotator')) {
    customElements.define('lbc-word-rotator', LbcWordRotator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbc-scent-slider"] && !Shopify.designMode) return;
  try {
    
  /**
   * Tabbed scent slider. Progressive enhancement: the markup ships with the
   * first slide active and the rest carrying [data-inactive]. If this never
   * runs, the first scent still renders in full and the root keeps the first
   * block's accent, which Liquid set.
   */
  class LbcScentSlider extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.lbc-scent-slide')];
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      if (this.slides.length < 2) return;

      this.index = 0;
      this.setAttribute('data-ready', '');

      this.querySelector('[data-lbc-scent-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-lbc-scent-next]')?.addEventListener('click', () => this.go(this.index + 1));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.go(Number(tab.dataset.index)));
        tab.addEventListener('keydown', (event) => this.onKeydown(event));
      });

      this.render();
    }

    /** Wraps around in both directions, so the arrows are never dead ends. */
    go(next) {
      const count = this.slides.length;
      this.index = ((next % count) + count) % count;
      this.render();
    }

    onKeydown(event) {
      const map = { ArrowLeft: -1, ArrowRight: 1, Home: 'first', End: 'last' };
      const move = map[event.key];
      if (move === undefined) return;
      event.preventDefault();

      if (move === 'first') this.go(0);
      else if (move === 'last') this.go(this.slides.length - 1);
      else this.go(this.index + move);

      this.tabs[this.index]?.focus();
    }

    render() {
      this.slides.forEach((slide, i) => {
        slide.toggleAttribute('data-inactive', i !== this.index);
        // Keeps hidden slides out of the accessibility tree and out of tab
        // order without removing them from layout - the stage relies on every
        // slide still occupying its grid cell to hold a stable height.
        slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
        slide.querySelectorAll('a, button').forEach((el) => {
          if (i === this.index) el.removeAttribute('tabindex');
          else el.setAttribute('tabindex', '-1');
        });
      });

      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', i === this.index ? 'true' : 'false');
        tab.setAttribute('tabindex', i === this.index ? '0' : '-1');
      });

      // Publish the active scent's colour so the shared controls (arrows) pick
      // it up. Per-slide elements read --lbc-slide-accent directly and don't
      // depend on this.
      const slide = this.slides[this.index];
      const section = this.closest('.lbc-scent-slider');
      if (!slide || !section) return;
      if (slide.dataset.accent) section.style.setProperty('--lbc-accent', slide.dataset.accent);
      // Per-slide background repaints the whole section band, not just the
      // slide's own box - the slides overlay in one grid cell, so a background
      // on the slide itself would only cover its own area. Empty means the
      // block left it unset, so fall back to the section's colour scheme.
      section.style.backgroundColor = slide.dataset.bg || 'var(--color-background)';
    }
  }

  if (!customElements.get('lbc-scent-slider')) {
    customElements.define('lbc-scent-slider', LbcScentSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
